import { ReportsTableList } from 'features/transaction_list/component/report-list/reports-table';
import { ReportFilterFormValues, ReportFilterFormValuesPaginated } from 'features/transaction_list/component/top-bar/report-filter-form/types';
import { ReportTopBar } from 'features/transaction_list/component/top-bar/reports-top-bar';
import { useGetReportsList } from 'features/transaction_list/use-cases/get-reports-exports';
import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';



export const ReportsListView = () => {

    const getInitialFilterValues: ReportFilterFormValues = {
        ReportType: undefined,

    };

    const { params, updateParams, resetPage } = usePaginationParams<any>({
        page: 1,
        size: 10,
        ...getInitialFilterValues
    });



    const { data, refetch, isFetching } = useGetReportsList(params, { retry: false });


    const handleFiltersChange = (values: ReportFilterFormValuesPaginated) => {
        updateParams(values);
        resetPage();
        refetch()
    };

    return (

        <>
            {/* <ContentTopBar
                title='Reports List'
                renderButtons={

                   

                }
            /> */}
            <ReportTopBar
                handleFilter={handleFiltersChange}
                initialValues={getInitialFilterValues}
                refetch={refetch}
                isFetching={isFetching}
            />

            {/* <ContentFilters formId={formId}>
                <ReportFilterForm
                    formId={formId}
                    handleFilter={handleFiltersChange}
                    initialValues={getInitialFilterValues}
                />
            </ContentFilters> */}

            <ReportsTableList
                isSocialListLoading={isFetching}
                DeliveryList={data}
                tableParams={params as any}
                updateParams={updateParams}
                refetch={refetch}
                isFetching={isFetching}

            />
            <Outlet />
        </>
    );
};
